module.exports = __webpack_public_path__ + "img/overbooking.3c345436.png";